<template>
    <div> 
        <div class="row">
            <div class="col-xl-2" >
                <SelectInput 
                    :label="$t('programme')" 
                    :options="programmes" 
                    optionLabel="Name" 
                    v-model="filter.programme"
                    
                    >
                </SelectInput>
            </div>
            <div class="col-xl-2" >
                <SelectInput 
                    :label="$t('placement-type')" 
                    :options="sessiontypes" 
                    optionLabel="ttsessiontype_name" 
                    v-model="filter.placement_type" 
                    v-if="mode.hee">
                </SelectInput>
            </div>
            <div class="col-xl-3">
                <SelectInput 
                    :label="$t('placement-provider-name')" 
                    :options="providers" 
                    optionLabel="placementprovider_title"
                    v-model="filter.provider" 
                    v-if="mode.hee">
                </SelectInput>

            </div>
            <div class="col-xl-5">
                <div class="d-flex flex-row align-items-end flex-wrap justify-content-xl-end" style="gap: 1rem" >
                    <DateInput :label="$t('from')" v-model="datetime.from" :min="timetable.datefrom"
                        :max="datetime.to < timetable.dateto ? datetime.to : timetable.dateto" />

                    <DateInput :disabled="!datetime.from" :label="$t('to')" v-model="datetime.to"
                        :min="datetime.from > timetable.datefrom ? datetime.from : timetable.datefrom"
                        :max="timetable.dateto" />
                    <button
                        type="button"
                        class="btn btn-outline-primary mb-3"
                        @click="buildHEE()"
                    >
                        {{ $t('go') }}<b-icon icon="arrow-right" />
                    </button>    
                </div>
                
            </div>

        </div>

		<div class="text-right mb-3">

			<button class="btn btn-outline-secondary ml-2" :title="$t('download')" @click="getCSV()">
				<b-icon-download /><!-- if a modal is implemented, make sure to have @click="shownew=true"-->
			</button>
		</div>

        <div class="sticky-container" v-if="loaded">
            <table class="table table-sm text-sm table-bordered table-timetable mt-3" :class="tableClass" v-if="mode.hee">
                <thead>
                    <tr>
                        <th>{{ $t('course-title') }}</th>
                        <th>{{ $t('placement-type') }}</th>
                        <th>{{ $t('placement-provider-name') }}</th>
                        <th>{{ $t('placement-postcode') }}</th>
                        <th>{{ $t('placement-provider-site') }}</th>
                        <th>{{ $t('month') }}</th>
                        <!--th>{{ $t('intake-month') }}</th-->
                        <th v-for="n in Array.from({ length: 5 }, (_, index) => index + 1)" :key="n">
                            {{ $t('year-{e}-hours', { e: n }) }}
                        </th>
                        <th>{{ $t('total-hours') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(course,key) in filteredCourses" :key="key">
                        <td>{{$config.getProgrammeNameById(course.programme) }}</td>
                        <td>{{ course.ttsessiontype_name }}</td>
                        <td>{{ course.placementprovider_title }}</td>
                        <td>{{ course.ttroom_postcode }}</td>
                        <td>{{ course.ttroom_name }}</td>
                        <td>{{ $t(`month-long-${course.month}`) }}</td>
                        <td v-for="y in Array.from({ length: 5 }, (_, index) => index + 1)" :key="y">
                            {{ getCourseHours(course[y] ? course[y]:null) }}
                        </td>
                        <td>{{ calculateTotalTime(course) }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <template v-else>
            <div>
                <div class="skeleton midnight h20 w100 mr-4 mb-3 float-left" v-for="n in 100" :key="n"></div>
            </div>
        </template>
        <!--MenuModal :show="shownew" @close="shownew = false" :getCSV="getCSV"/-->
    </div>
</template>

<script>
import DateInput from "src/components/Inputs/DateInput";
import Papa from 'papaparse';
//import MenuModal from "src/components/Timetables/DownloadTTModal.vue";


export default {
    components: {
        DateInput,
        //MenuModal
    },
    data() {
        return {
            loaded: false,
            shownew: false,
            sessiontypes: [],
            timetable: [],
            modes: [],
            filter: {},
            programmes: this.$config.getValue('programmes'),
            years: [],
            calcYears: {},
            groups: this.$config.getValue('groups'),
            total_time_per_student: [],
            datetime:{},
            view:{
                days: false,
                hours: false,
                all: true,
                break: true
            },
            mode:{
                default:true,
                hee: false, 
            },
            courses: [],
            providers:[],
            error: null,
            breakdown:{}, 
            user:{
                providers: []
            }
        }
    },
    mounted() {
        this.isPlacementProvider();
        this.buildHEE();
        
    },
    methods: {
        buildHEE() {
            this.courses=[];
            let datetime ={};
            this.loaded = false;
            if(this.datetime.from && this.datetime.to){
                /*
                We make sure that datetime_from begins at the start of the day
                and that datetime_to finishes at the end of it
                */
                datetime.from = `${this.datetime.from} 0:0:0`;
                datetime.to = `${this.datetime.to} 23:59:59`;
            }


            this.$cfetch(`${this.$settings.APIBaseURL}/timetables/events/getheetime`, {
                data: {
                    tttimetable_id: this.$route.params["timetableid"]
                    ? Number(this.$route.params["timetableid"]) : null,
                    programme: this.$route.params["programme"],
                    year: this.$route.params["year"],
                    group: this.$route.params["group"],
                    time: ('time' in this.$route.query) ? this.$route.query.time : null,
                    datetime_from: datetime.from,
                    datetime_to: datetime.to,
                },
            }).then((res) => {
                if (res.status === "SUCCESS") {
                    this.loaded = true;
                    this.courses = res.results;
                    this.sessiontypes = res.sessiontypes;
                    this.providers = res.providers;

                } else {
                    if (res.error_message) {
                        this.error = res.error_message;
                    } else {
                        this.error = this.$t("failed-load-timetable");
                    }
                }
            });
        },

        handleHEETT(){
            let timetable = this.courses;
            //Format keys for CSV
            const csvCols = {
                "1": "Year 1 Hours",
                "2": "Year 2 Hours",
                "3": "Year 3 Hours",
                "4": "Year 4 Hours",
                "5": "Year 5 Hours"
            }
            let formattedTimetable=[];
            formattedTimetable = Object.keys(timetable).map((key) => {
                const course = timetable[key];

                const formattedCourse = {
                	"Course Title": this.$config.getProgrammeNameById(course.programme),
                    "Placement Type": course.ttsessiontype_name,
                    "Placement Provider Name": course.placementprovider_title,
                    "Placement Postcode": course.ttroom_postcode,
					"Placement Provider Site": course.ttroom_name,
					"Month": this.$t(`month-long-${course.month}`)
                }

                for (let year = 1; year <= 5; year++) {// rename key if needed
                	formattedCourse[csvCols[year]] = this.getCourseHours(course[year]);
                }

                formattedCourse["Total Hours"] = this.calculateTotalTime(course);
                
                return formattedCourse;
            });

            return formattedTimetable;
        },
        getCSV() {
            let timetable =[]
            if(this.mode.default){
                timetable = this.handleRegularTT(this.filteredTimetable);
            }

            if(this.mode.hee){
                timetable=this.handleHEETT()
            }

            // Get the CSV via a Promise
            return new Promise((resolve, reject) => {
                try {
                    const csv = Papa.unparse(timetable);
                    resolve(csv);
                } catch (error) {
                    console.error('Error unparsing CSV file:', error);
                    reject(error);
                }
            }).then(res => {
                // Create a Blob from the CSV string
                const blob = new Blob([res], { type: 'text/csv' });

                // Give it a download link
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = 'data.csv';

                // Trigger download
                a.click();

                // Housekeeping
                URL.revokeObjectURL(url);
            });
        },
        addEventsForStudent(student){
            let sum = 0;

            for (const sessionId in student.sessiontypes) {
                sum += parseInt(student.sessiontypes[sessionId].num_events);
            }

            return sum;
        },

        isPlacementProvider(){
            if(this.$UserSession.hasPriv.call(this,'PLACEMENT_MY_PLACEMENTS')
            && !this.$UserSession.hasPriv.call(this,'ALL') ){
                this.mode.hee = true;
                this.mode.default = false;
                return true;
            }
            return false;
        },

    },
    computed: {
        tableClass: function () {
            if (Object.keys(this.courses).length > 25) {
                return 'table-timetable-sm'
            }
            return '';
        },
        parseYearsForProgramme() {
            let programme = {};
            if (this.filter.programme) {
                programme = this.filter.programme;
            }

            let arr_years = []

            for (var i = 1; i <= programme["CourseLengthYears"]; i++) {
                arr_years.push(i);
            }

            return arr_years;
        },
        filteredCourses() {
            let filteredCourses = {};

            if (Object.keys(this.filter).length === 0
                || Object.values(this.filter).every(value => value === null)) {
                // If there are no filters, the default courses are passed
                filteredCourses = this.courses;
            } else {
                for (var key in this.courses) {
                    var obj = this.courses[key];

                    if (obj && typeof obj === 'object' && 'programme' in obj) {
                        if (
                            (!this.filter.programme || obj.programme === this.filter.programme['Id'])
                            && (!this.filter.placement_type || obj.session_id == this.filter.placement_type.session_id)
                            && (!this.filter.provider || obj.placementprovider_id == this.filter.provider.placementprovider_id)) {

                            filteredCourses[key] = obj;
                        }
                    }
                }
            }
            return filteredCourses;
        },
        getHours(){
            return (sessiontype) =>{
                if(this.view.break && sessiontype.break_time){
                    return Math.round((sessiontype.total_time - sessiontype.break_time*sessiontype.num_events) / 36)/100;
                }
                return Math.round(sessiontype.total_time / 36)/100; // f[(x/3600)*100]/100=f[x/36]/100
            }

        },
        getCourseHours(){
            return (courseYear) => {
                if(!courseYear) return 0;
                if(this.view.break && courseYear.break_time){
                    return Math.round((courseYear.total_time - courseYear.break_time) / 36)/100;
                }
                return Math.round(courseYear.total_time / 36)/100; // f[(x/3600)*100]/100=f[x/36]/100
            }
        },
        aggregateStudentHours(){
            return (student) => {
                let sum = 0;
                for(let session in student.sessiontypes){
                    sum += this.getHours(student.sessiontypes[session])
                }
                return sum;
            }
        },
        aggregateSessionHours(){
            return (session) => {
                let sum = 0;

                for (let key in this.filteredTimetable){
                    const student = this.filteredTimetable[key];
                    if(session.id in student.sessiontypes){
                        sum += this.getHours(student.sessiontypes[session.id])
                    }

                }
                return sum;
            }
        },
        aggregateSessionDays(){
            return (session) => {
                let sum = 0;

                for (let key in this.filteredTimetable){
                    const student = this.filteredTimetable[key];
                    if(session.id in student.sessiontypes){
                        sum += student.sessiontypes[session.id].num_events;
                    }

                }
                return sum;
            }
        },
        calculateTotalTime(){
            return (course) => {
                let total=0;

                for (let year = 1; year <= 5; year++){
                	if(course[year]){
                    	total += this.getCourseHours(course[year]);
                    }
                }

                return total !==0 ? total  : 0 ;
            }

        },
    }
};
</script>
